import { render } from "./CarouselUnitResearch.vue?vue&type=template&id=62f050d2"
import script from "./CarouselUnitResearch.vue?vue&type=script&lang=js"
export * from "./CarouselUnitResearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselUnitResearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f050d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f050d2', __exports__)) {
    api.reload('62f050d2', __exports__)
  }
  
  module.hot.accept("./CarouselUnitResearch.vue?vue&type=template&id=62f050d2", () => {
    api.rerender('62f050d2', render)
  })

}


export default __exports__